/**
 * Postback 規則 API Service
 */

import apiClient from '../axios.js';

export const postbackRuleService = {
  async list(params) {
    return apiClient.get('/admin/auto-reply/postback-rules', { params });
  },

  async get(id) {
    return apiClient.get(`/admin/auto-reply/postback-rules/${id}`);
  },

  async create(data) {
    return apiClient.post('/admin/auto-reply/postback-rules', data);
  },

  async update(id, data) {
    return apiClient.put(`/admin/auto-reply/postback-rules/${id}`, data);
  },

  async remove(id) {
    return apiClient.delete(`/admin/auto-reply/postback-rules/${id}`);
  }
};
